<ng-template #template>
<div class="sv-tagbox__item">
  <div class="sv-tagbox__item-text" [model]="item.locText" sv-ng-string></div>  
  <div [class]="question.cssClasses.cleanItemButton" (click)="removeItem($event)">
    <svg [iconName]="question.cssClasses.cleanItemButtonIconId" [partCss]="question.cssClasses.cleanItemButtonSvg" [size]="'auto'" sv-ng-svg-icon></svg>
  </div>
</div>
</ng-template>